<template>
  <sup>
    <v-icon small :color="getSocialiteColor(driver)" style="text-shadow:none;">{{getSocialiteIcon(driver)}}</v-icon>
  </sup>
</template>

<script>
import socialiteMixin from "@/mixins/socialiteMixin"

export default {
  name: "TwitchSign",
  mixins: [socialiteMixin],
  props: {
    color: {
      type: String,
      required: false
    },
    driver: {
      type: String,
      required: true
    }
  },
};
</script>
